import { Component, inject, model } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { ProfileService } from '../../profile/services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { RoleModel } from '../../shared/models/role.model';
import { RoleFormComponent } from "../role-form/role-form.component";
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-role-details',
  standalone: true,
  imports: [RoleFormComponent],
  templateUrl: './role-details.component.html',
  styleUrl: './role-details.component.css'
})
export class RoleDetailsComponent {
  service = inject(RolesService)
  profile = inject(ProfileService).profile
  access = inject(AccessService).access
  route = inject(ActivatedRoute)

  id!: string | null;

  value = model<RoleModel | undefined>(undefined)

  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles del Rol')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getValue(params.get('id'));
    });
  }

  getValue(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.valueService.valueDetailed(id);
      this.service.get(id).subscribe((data) => {
        this.value.update(value => (value = data as RoleModel));
      });
    }
  }
}
